import React from 'react';
import { Box, Flex, DeprecatedIcon, Tooltip, Text } from '@fullstory/components';
import { EngagementMapsDetailsRow } from '../EngagementMapsDetailsRow';
import { INDEX_ADJUSTED_TIME_RANGE_MESSAGE } from '@fullstory/pages-shared';
import { FormattedMessage, useIntl } from 'react-intl';

export interface TimeFrameRowProps {
  timeFrame: string;
  showTimeFrameWarning?: boolean;
}

export const TimeFrameRow: React.FC<TimeFrameRowProps> = ({ timeFrame, showTimeFrameWarning }) => {
  const intl = useIntl();
  return (
    <EngagementMapsDetailsRow
      data-component="TimeFrameRow"
      icon={{ name: 'clock' }}
      label={{ body: intl.formatMessage({ defaultMessage: 'Time Frame: ', id: '9uPEi7' }) }}
      value={
        showTimeFrameWarning ? (
          <Flex justifyContent="flex-start">
            <Box marginRight={12}>
              <Tooltip placement="top" tooltipContent={INDEX_ADJUSTED_TIME_RANGE_MESSAGE}>
                <DeprecatedIcon name="error-warning-fill" color="yellow-base" size={16} />
              </Tooltip>
            </Box>
            <Text appearance="bodySmall" tag="div" noWrap>
              {timeFrame}
            </Text>
          </Flex>
        ) : (
          {
            body: timeFrame,
          }
        )
      }
      tooltipContent={
        !showTimeFrameWarning ? (
          <Box>
            <Text appearance="bodySmall" color="inherit">
              <FormattedMessage
                defaultMessage="The time frame of the data derived from the current segment."
                id="vwCOIk"
              />
            </Text>
          </Box>
        ) : undefined
      }
    />
  );
};
